function Spinner({spinner, text}) {  
    return (
        <div ref={spinner} id="spinner" className="spinner">
            <div><div className="spinner-container" /><span> Loading ...</span></div>
        </div>
    )
}

export default Spinner